<template>
  <div>
    <v-container fluid>
      <v-overlay
        v-model="showSuccess"
        :scrim="true"
        opacity="0.3"
        persistent
        :z-index="9990"
      >
      </v-overlay>
      <transition name="fade-slide">
        <output v-if="showSuccess" class="success-toast">
          <img src="@/assets/mdi_success-bold.svg" alt="img" width="20" height="20" />
          <span style="font-size: 14px; font-weight: 600;">{{ successMessage }}</span>
        </output>
      </transition>
      <h2 class="heading-text">{{ pageTitle }}</h2>
      <div class="mt-2 mb-4"><hr /></div>
      <v-card class="card2">
        <div class="d-flex justify-space-between align-center">
          <div class="d-flex justify-start align-center gap-2">
            <img src="@/assets/mdi_information-variant-box.svg" alt="img" width="20" height="20">
            <p style="color: #171717; font-size: 18px; font-weight: 600;">{{ $t("questionSetInformation") }}</p>
          </div>
          <div class="d-flex justify-start align-center gap-2">
            <button type="button" id="button-process-validationnegativedetail"
              class="process-btn"
              @click="Save()"
              :disabled="!searchNegativeName || !request.entity"
              :style="!searchNegativeName || !request.entity ? 'background-color: #C1C3CB;' : 'background-color: #3859D0;'"
            >
              <img src="@/assets/flat-color-icons_process.svg" alt="img" width="16" height="16" />
              <span style="color: #ffffff; font-size: 13px;">{{ $t("process") }}</span>
            </button>

            <button type="button" @click="download" class="template-btn">
              <img src="@/assets/lucide_download.svg" alt="img" width="16" height="16" />
              <span style="color: #C32E0E; font-size: 13px">{{ $t("template") }}</span>
            </button>
          </div>
        </div>
        <v-row class="mt-4">
          <v-col cols="12" sm="12" md="6">
            <div class="d-flex justify-start align-center gap-2">
              <label for="">{{ $t("questionSetName") }}</label>
              <v-tooltip location="top" max-width="230px">
                <template v-slot:activator="{ props }">
                  <img
                    v-bind="props"
                    src="@/assets/intent group toolip.svg"
                    alt="info"
                    width="18"
                    height="18"
                    style="cursor: pointer; margin-left: 4px;"
                  />
                </template>
                <span>{{ $t("_negativeQuestionSetNameTooltip") }}</span>
              </v-tooltip>
            </div>
            <v-text-field
              id="questionsetname-field-validationnegativedetail"
              :placeholder="$t('_enterNegativeQuestionSetName')"
              :rules="[rules.required]"
              :disabled="actionEdit"
              v-model="searchNegativeName"
              variant="none"
              density="comfortable"
              color="grey"
              class="modern-text-field"
              clearable
              hide-details="auto"
              :readonly="!!nId"
            >
            </v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="6">
            <div class="d-flex justify-start align-center gap-2">
              <label for="">{{ $t("uploadFile") }}</label>
              <v-tooltip location="top" max-width="230px">
                <template v-slot:activator="{ props }">
                  <img
                    v-bind="props"
                    src="@/assets/intent group toolip.svg"
                    alt="info"
                    width="18"
                    height="18"
                    style="cursor: pointer; margin-left: 4px;"
                  />
                </template>
                <span>{{ $t("_importExcelNegativeTooltip") }}</span>
              </v-tooltip>
            </div>

            <div class="upload-box mt-2">
              <div class="upload-inner">
                <button type="button" @click="triggerFileUpload" class="upload-btn-core">
                  <img :src="iconImage" alt="icon" width="18" height="18" />
                  <span style="font-size: 14px;">{{ uploadedFiles.length > 0 ? $t('changeFile') : $t('uploadFile') }}</span>
                </button>

                
                <div class="mt-1" style="display: flex; align-items: center; gap: 8px;">
                  <img src="@/assets/intent group toolip.svg" alt="img-icon" width="18" height="18" />
                  <span class="upload-hint">{{ $t("_supportFormatsXlsx") }}</span>
                </div>

                <!-- added xlsx file -->
                 <v-card v-if="uploadedFiles.length > 0" class="files-card" elevation="2">  
                  <v-virtual-scroll :items="uploadedFiles">
                    <template v-slot:default="{ item }">
                      <v-list-item class="file-item">
                        <template v-slot:prepend class="d-flex justify-center align-center">
                          <img src="@/assets/file-excel.svg" alt="img-icon" width="20" height="20" />
                        </template>

                        <v-list-item-title>
                          <span style="color: #171717;">{{ item.name }}</span>
                        </v-list-item-title>
                      </v-list-item>
                      <v-divider class="mx-4" v-if="uploadedFiles.indexOf(item) < uploadedFiles.length - 1" />
                    </template>
                  </v-virtual-scroll>
                </v-card>
              </div>
            </div>

            <!-- Hidden Drag Drop File Component -->
            <DragDropFile
              ref="dragDropComponent"
              :dialog="true"
              :DragDrop="false"
              :ShowListFile="false"
              :allowType="['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']"
              @filesUploaded="processUpload($event)"
              class="upload-component"
              style="display: none;"
            />
          </v-col>
        </v-row>
      </v-card>

      <v-card class="card2" style="margin-top: 1rem">
        <div class="d-flex justify-space-between align-center">
          <div>
            <h3 class="mb-4" style="font-weight: 700;">{{ $t("negativeQuestionSetTable") }}</h3>
          </div>
          <div class="d-flex justify-start align-center gap-2 mb-4">
            <!-- Delete Selected Button -->
            <button type="button"
              v-if="showTable && dataTable.length > 0 && selectedRows.length > 0 && selectedRows.length < dataTable.length"
              variant="none"
              color="error"
              @click="openDeleteDialog('selected')"
              class="delete-selected-btn"
              >
              <div class="d-flex justify-start align-center gap-2">
                <img src="@/assets/heroicons_trash.svg" alt="img" width="20" height="20">
                <span style="color: #C32E0E; font-size: 15px; font-weight: 500;">{{ $t('deleteSelected') }}</span>
              </div>
            </button>
              
            <!-- Delete All Button -->
            <button type="button"
              id="button-deleteall-validationnegativedetail"
              v-if="showTable == true && dataTable.length > 0 && selectedRows.length === dataTable.length"
              variant="none"
              color="error"
              @click="openDeleteDialog('all', nId)"
              class="deletall-btn"
              >
              <div class="d-flex justify-start align-center gap-2">
                <img src="@/assets/heroicons_trash.svg" alt="img" width="20" height="20">
                <span style="color: #C32E0E; font-size: 15px; font-weight: 500;">{{ $t('deleteAll') }}</span>
              </div>
            </button>
          </div>
        </div>

          <v-data-table-server
            v-if="showTable == true"
            :items-per-page="itemsPerPage"
            :items-length="searchTotalTable"
            v-model:options="options"
            v-model="selectedRows"
            :items="dataTable"
            :headers="headers"
            :loading="loadingTable"
            :loading-text="$t('loading')"
            show-select
            @update:model-value="handleSelectionChange"
            item-value="negativeID"
            return-object
          >
            
            <template v-slot:header.data-table-select="{ props }">
              <v-checkbox-btn
                v-bind="props"
                :indeterminate="false"
                :model-value="dataTable.length > 0 && selectedRows.length === dataTable.length"
                @update:model-value="toggleSelectAll"
              />
            </template>

           
            <template v-slot:item.number="{ item, index }">
              <div style="width: 80px; text-align: left;">
                {{ item.number ?? (index + 1) }}
              </div>
            </template>

            <template v-slot:item.question="{ item }">
              <div class="text-ellipsis">{{ item.question }}</div>
            </template>
            <template v-slot:item.actions="{ item }">
              <div style="text-align: center">
                <button
                  type="button"
                  id="button-delete-validationnegativedetail"
                  @click="openDeleteDialog('single', item.negativeID)"
                >
                  <v-tooltip location="top" max-width="230px">
                    <template v-slot:activator="{ props }">
                      <img
                        v-bind="props"
                        src="@/assets/Group.svg"
                        alt="img"
                        width="22"
                        height="19"
                      />
                    </template>
                    <span>{{ $t("delete") }}</span>
                  </v-tooltip>
                </button>
              </div>
            </template>

            <template #no-data>
              <div style="text-align: center;">
                <span style="color: #646464; font-weight: 400;">{{ $t("noDataAvailable") }}</span>
              </div>
            </template>

            <template v-slot:bottom>
              <div class="d-flex justify-space-between align-center px-4 py-2" style="width: 100%">
                <div>{{ $t("totalResults") }} {{ searchTotalTable }}</div>

                <div class="d-flex align-center" style="gap: 8px;">
                  <v-data-table-footer
                    :items="[
                      { text: '10', value: 10 },
                      { text: '25', value: 25 },
                      { text: '50', value: 50 },
                      { text: '100', value: 100 },
                      { text: 'All', value: -1 },
                    ]"
                    :page="options.page"
                    :length="Math.ceil(searchTotalTable / itemsPerPage)"
                  />
                </div>
              </div>
            </template>
          </v-data-table-server>

          <v-dialog v-model="showDeleteDialog" max-width="540">
            <v-card class="delete-dialog-card">
              <v-card-title class="card-dialog-title" style="background-color: #FFF2F2;">
                <span class="delete-dialog-title">{{ $t("deleteConfirmation") }}</span>
                <v-btn icon variant="text" density="comfortable" @click="closeDeleteDialog">
                  <img src="@/assets/Vector.svg" alt="icon" width="12" height="12">
                </v-btn>
              </v-card-title>
              <v-divider></v-divider>

              <v-card-text v-if="deleteDialogMode === 'single'" class="pt-6 pb-4 px-4 body-text">
                <span style="color: #171717; font-weight: 500; font-size: 15px;">{{ $t("_confirmDeleteThisQuestion") }}</span>
              </v-card-text>

              <v-card-text v-else-if="deleteDialogMode === 'selected'" class="pt-6 pb-4 px-4 body-text">
                <span style="color: #171717; font-weight: 500; font-size: 15px;">{{ $t("_confirmDeleteSelectedQuestions") }}</span>
              </v-card-text>

              <v-card-text v-else-if="deleteDialogMode === 'all'" class="pt-6 pb-4 px-4 body-text">
                <span style="color: #171717; font-weight: 500; font-size: 15px;">{{ $t("_confirmDeleteAllQuestionsInTable") }}</span>
              </v-card-text>

              <hr style="border: none; border-top: 1px solid #c9c9c9;" />
              <v-card-actions class="px-6 pb-3 pt-3 pl-8 justify-end" style="gap: 12px;">
                <v-btn v-if="deleteDialogMode === 'single'" class="delete-confirm-btn" :loading="deleting" @click="DeleteById()">
                  <img src="@/assets/heroicons_trash-solid.svg" alt="img" width="17" height="22" class="mr-2">
                  <p style="color: #ffffff; font-size: 14px; font-weight: 500;">{{ $t("delete") }}</p>
                </v-btn>

                <v-btn v-else-if="deleteDialogMode === 'selected'" class="delete-confirm-btn" :loading="deleting" @click="deleteSelectedRows()">
                  <img src="@/assets/heroicons_trash-solid.svg" alt="img" width="17" height="22" class="mr-2">
                  <p style="color: #ffffff; font-size: 14px; font-weight: 500;">{{ $t("delete") }}</p>
                </v-btn>

                <v-btn v-else-if="deleteDialogMode === 'all'" class="delete-confirm-btn" :loading="deleting" @click="DeleteByName()">
                  <img src="@/assets/heroicons_trash-solid.svg" alt="img" width="17" height="22" class="mr-2">
                  <p style="color: #ffffff; font-size: 14px; font-weight: 500;">{{ $t("delete") }}</p>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </v-card>
    </v-container>
    
    <v-overlay :model-value="loadingTable || dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">{{ $t("loading") }}</h3>
          <p class="loading-subtitle">{{ $t("pleaseWait") }}</p>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>
<script>
import DragDropFile from '@/components/DragDropFile.vue';
import ExcelJS from "exceljs";
import editImg from '@/assets/edit1.png';
import deleteImg from '@/assets/delete1.png';
import iconImage from "@/assets/upload-cloud-2-line.svg";

export default {
  name: 'ValidationNegativeDetail',
  inject: ['flagNav','FontColorTitle','SubNavbarBackGround'],
  components: { DragDropFile },
  emits: ['filesUploaded', 'back'],
  props: {
    id: { type: [String, Number] }
  },
  computed: {
    pageTitle() {
      const isEditMode = !!this.actionEdit || !!this.nId || !!(this.$route && this.$route.query && this.$route.query.id);
      return isEditMode ? this.$t('_EditNegativeQuestionSet') : this.$t('_UploadNegativeQuestionSet');
    },
    headers() {
      return [
        {
          title: this.$t('no'),
          align: 'left',
          sortable: false,
          value: 'number',
        },
        { title: this.$t('question'), align: 'left', sortable: true, value: 'question' },
        { title: this.$t('manage'), align: 'center', sortable: false, value: 'actions' },
      ];
    },
  },
  data() {
    return {
    selectedRows: [],
    showDeleteSelected: false,
    showSuccess: false,
    successMessage: "",
    _toastTimer: null,
    itemToDelete: null,
    deleteDialogMode: null, // 'single' | 'selected' | 'all'
    deleteAllName: null,
    deleting: false,
    showDeleteDialog: false,
    iconImage,
    isInitialized: false,
    uploadDialog: false,
    checkbox1: false,
    actionEdit: false,
    dialog: false,
    loadingTable: false,
    loading: true,
    loadingDownload: true,
    today: null,
    searchNegativeName: null,
    nId: null,
    request: {
      name: null,
      entity: null,
    },
    options: {
      page: 1,
      sortBy: [],
      sortDesc: [],
      itemsPerPage: 10,
    },
    files: [],
    dataTable: [],
    uploadedFiles: [],
    isSearch: false,
    isFirst: true,
    itemsPerPage: 10,
    searchTotalTable: 0,
    totalTable: 0,
    showTable: false,
    dataUpdate: 0,
    dataAll: 0,
    exceptionFlag: false,
    rules: {
      required: (value) => !!value || this.$t('Required'),
    },
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    sortBy: [],
    sortDesc: [],
    };
  },
  watch: {
    options: {
      handler() {
        if(!this.isInitialized) return;
        this.Get();
      },
      deep: true,
    },
    dataTable: {
      handler() {
        this.selectedRows = [];
        this.showDeleteSelected = false;
      },
      deep: true,
    },
    selectedRows: {
      handler() {
        // handled by @update:selected
      },
      deep: true,
    },
  },
  methods: {
    handleSelectionChange(selected) {
      const safeSelected = Array.isArray(selected) ? selected : [];
      this.selectedRows = safeSelected;
      this.showDeleteSelected =
        safeSelected.length > 0 && safeSelected.length < this.dataTable.length;
    },
    toggleSelectAll(checked) {
      this.selectedRows = checked ? [...this.dataTable] : [];
      this.handleSelectionChange(this.selectedRows);
    },
    deleteSelectedRows() {
      if (this.deleting) return;
      if (!Array.isArray(this.selectedRows) || this.selectedRows.length === 0) return;

      const ids = this.selectedRows
        .map((row) => (row && typeof row === 'object' ? row.negativeID : row))
        .filter((id) => id !== undefined && id !== null);

      if (ids.length === 0) return;

      this.deleting = true;
      this.dialog = true;
      this.showDeleteDialog = false;

      Promise.all(
        ids.map(
          (id) =>
            new Promise((resolve) => {
              this.$call.DeleteValidationNegativeDetail(
                id,
                () => resolve(),
                (errorResource) => {
                  console.error(errorResource);
                  resolve();
                }
              );
            })
        )
      ).then(() => {
        this.dialog = false;
        this.deleting = false;
        this.selectedRows = [];
        this.showDeleteSelected = false;
        this.successMessage = 'Successfully Deleted !';
        this.showSuccess = true;
        clearTimeout(this._toastTimer);
        this._toastTimer = setTimeout(() => {
          this.showSuccess = false;
        }, 3000);
        this.Get();
      });
    },
    openDeleteDialog(mode, payload) {
      if (mode === 'selected') {
        this.deleteDialogMode = 'selected';
        this.itemToDelete = null;
        this.deleteAllName = null;
      } else if (mode === 'all') {
        this.deleteDialogMode = 'all';
        this.deleteAllName = payload ?? this.nId;
        this.itemToDelete = null;
      } else if (mode === 'single') {
        this.deleteDialogMode = 'single';
        this.itemToDelete = payload;
        this.deleteAllName = null;
      } else {
        this.deleteDialogMode = 'single';
        this.itemToDelete = mode;
        this.deleteAllName = null;
      }

      this.showDeleteDialog = true;
    },
    closeDeleteDialog() {
      if (this.deleting) return;
      this.showDeleteDialog = false;
      this.itemToDelete = null;
      this.deleteDialogMode = null;
      this.deleteAllName = null;
    },
    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Number.parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },
    triggerFileUpload() {
      if (this.$refs.dragDropComponent) {
        // หากมี method เปิด dialog ใน DragDropFile
        if (typeof this.$refs.dragDropComponent.openFileDialog === 'function') {
          this.$refs.dragDropComponent.openFileDialog();
        } 
        // หรือหากมี input file ใน component
        else if (this.$refs.dragDropComponent.$el) {
          const fileInput = this.$refs.dragDropComponent.$el.querySelector('input[type="file"]');
          if (fileInput) {
            fileInput.click();
          }
        }
        // หรือใช้วิธีสร้าง input file เอง
        else {
          this.openFileSelector();
        }
      } else {
        // สำรองในกรณีที่ ref ไม่ทำงาน
        this.openFileSelector();
      }
    },
    Get() {
      this.loadingTable = true;
      let { page, itemsPerPage, sortBy } = this.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }
      let temp = {
        page: this.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : this.totalTable, // NOSONAR
        name: this.nId,
        sortDesc: sortOrder,
        sortBy: sortField
      };
      this.$call.GetTableValidationNegativeDetail(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            if(dataResponse.data == undefined || dataResponse.data == null)
            {
              this.dataTable = [];
              this.searchTotalTable = 0;
              this.totalTable = 0;
            }
            else
            {
              this.searchTotalTable = dataResponse.data.total;
              this.dataTable = dataResponse.data.data;
              if (dataResponse.data.data != undefined && dataResponse.data.data != null && dataResponse.data.data.length > 0) {
                this.searchNegativeName = dataResponse.data.data[0].name;
              }
              this.totalTable = this.isFirst ? dataResponse.data.total : this.totalTable;
            }
          }
          else
          {
            this.dataTable = [];
            this.searchTotalTable = 0;
            this.totalTable = 0;
          }
          this.loadingTable = false;
          this.isSearch = false;
          this.isFirst = false;
          this.showTable = true;
        },
        (errorResource) => {
          this.loadingTable = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    Save() {
      if (!this.searchNegativeName || !this.request.entity) {
        this.$swal.fire({
          icon: 'warning',
          title: this.$t("_pleaseFillAllFields"),
          showConfirmButton: false,
          timer: 2500,
        });
      }
      else
      {
        this.showTable = false;
        this.request.name = this.searchNegativeName;
        this.dialog = true;
        try {
          this.$call.UploadValidationNegative(
            this.request,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                this.successMessage = this.$t("_successfullyProcessed");
                this.showSuccess = true;
                clearTimeout(this._toastTimer);
                this._toastTimer = setTimeout(() => {
                  this.showSuccess = false;
                }, 3000);
                this.actionEdit = true;
                this.isFirst = true;
                this.showTable = true;
                this.nId = dataResponse.data
                this.searchNegativeName = this.request.name;
                this.request.entity = null;
                this.uploadedFiles = [];
                if (this.$route.query.id !== String(this.nId)) {
                    globalThis.location.href = `${this.$route.path}?id=${this.nId}`;
                }
              }
              this.dialog = false;
            },
            (errorResource) => {
              this.dialog = false;
              console.error(errorResource);
            }
          );
        } catch (error) {
          this.LogTrace(error, 'DeleteGroup');
        }
      }
    },
    processUpload(e) {
      this.files = e;
      if (this.files.length == 0) {
        this.request.entity = null;
        this.uploadedFiles = [];
        return;
      }
      const reader = new FileReader();
      reader.readAsText(this.files[0]); // NOSONAR
      reader.onload = () => {
        let text = reader.result;
        this.ValidateCSV(text, this.files);
      };
    },
    ValidateCSV(csv, files) {
      const formDataDoc = new FormData();
      formDataDoc.append("entity", files[0]);
      this.uploadedFiles = files;
      this.request.entity = formDataDoc;
    },
    removeFile(fileName) {
      const index = this.uploadedFiles.findIndex((file) => file.name === fileName);
      if (index > -1) this.uploadedFiles.splice(index, 1);
      this.$emit('filesUploaded', this.uploadedFiles);
    },
    DeleteById() {
      if (!this.itemToDelete || this.deleting) return;
      this.deleting = true;
      this.dialog = true;
      this.showDeleteDialog = false;
      this.$call.DeleteValidationNegativeDetail(
        this.itemToDelete,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.itemToDelete = null;
              this.successMessage = this.$t("successfullyDeleted");
              this.showSuccess = true;
              clearTimeout(this._toastTimer);
              this._toastTimer = setTimeout(() => {
                this.showSuccess = false;
              }, 3000);
              this.Clear();
              this.Get();
            }
            this.dialog = false;
            this.deleting = false;
          },
          (errorResource) => {
            this.dialog = false;
            this.deleting = false;
            this.Adddialog = false;
            console.error(errorResource);
          }
      );
    },
    DeleteByName(name) {
      if (this.showDeleteDialog && this.deleteDialogMode === 'all') {
        const targetName = name ?? this.deleteAllName ?? this.nId;
        if (!targetName || this.deleting) return;

        this.deleting = true;
        this.dialog = true;
        this.showDeleteDialog = false;
        this.$call.DeleteValidationNegative(
          targetName,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              this.successMessage = this.$t("successfullyDeleted");
              this.showSuccess = true;
              clearTimeout(this._toastTimer);
              this._toastTimer = setTimeout(() => {
                this.showSuccess = false;
              }, 3000);
              this.Clear();
            }
            this.dialog = false;
            this.deleting = false;

            setTimeout(() => {
                this.$router.push('/ValidationNegative');
            }, 2000);
          },
          (errorResource) => {
            this.dialog = false;
            this.deleting = false;
            this.Adddialog = false;
            console.error(errorResource);
          }
        );
        return;
      }
      try {
        this.$swal
          .fire({
            title: this.$t('confirmDeletion'),
            text: this.$t('confirmDeletionAllQuestion'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.dialog = true;
              this.$call.DeleteValidationNegative(
                name,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    this.successMessage = this.$t("successfullyDeleted");
                    this.showSuccess = true;
                    clearTimeout(this._toastTimer);
                    this._toastTimer = setTimeout(() => {
                      this.showSuccess = false;
                    }, 3000);
                    this.Clear();
                  }
                  this.dialog = false;
                  this.$router.push('/ValidationNegative');
                },
                (errorResource) => {
                  this.dialog = false;
                  this.Adddialog = false;
                  console.error(errorResource);
                }
              );
            }
          });
      } catch (error) {
        this.LogTrace(error, 'DeleteGroup');
      }
    },
    Clear() {
      this.showTable = false;

      this.request.entity = null;
      this.request.name = null;

      this.searchNegativeName = null;
      this.dataTable = [];
      this.searchTotalTable = 0;
      this.totalTable = 0;

      this.$emit('back', true);
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1;

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = '0' + dd;
      }
      if (mm < 10) {
        mm = '0' + mm;
      }

      this.today = dd + '/' + mm + '/' + yyyy;
    },
    async download(){
      const data = [
        {
          Questions: "จังหวัดที่อยู่เหนือสุดของประเทศไทย"
        },
        {
          Questions: "จังหวัดที่อยู่ใต้สุดของประเทศไทย"
        },
        {
          Questions: "จังหวัดที่มีพื้นที่มากที่สุดของประเทศไทย"
        },
      ];

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Sheet1");

      // Add headers
      worksheet.columns = [
        { header: "Questions", key: "Questions", width: 30 }
      ];

      // Add rows
      data.forEach((item) => {
        worksheet.addRow(item);
      });

      // Style the header row
      worksheet.getRow(1).font = { bold: true };

      // Generate Excel file
      const buffer = await workbook.xlsx.writeBuffer();

      // Create a blob and download
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = globalThis.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "upload_questions.xlsx";
      a.click();
      globalThis.URL.revokeObjectURL(url);
    },
  },
  mounted() {
    this.GetDate();
    if (this.$route.query.id) {
      this.searchNegativeName = this.$route.query.id;
      this.nId = this.$route.query.id;
      this.showTable = true;
      this.actionEdit = true;
    }
    this.Get();
    this.isInitialized = true;
  },
};
</script>
<style scoped>
  .success-toast {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(100deg,#1e863d,#135928);
  color: #ffffff;
  display: flex;
  align-items: center !important;
  font-size: 14px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  z-index: 2100;
  width: 50%;
  max-width: 900px;
  min-width: 320px;
  justify-content: center !important;
  padding: 12px;
  border: 1px solid #ffffff;
  gap: 20px;
  margin-top: 100px;
}
.heading-text {
  color: #171717;
  font-weight: 700;
  font-size: 22px;
}
hr {
border: none;
border-top: 1px solid #c9c9c9;
}
.card2 {
  padding: 20px;
  border: 1px solid #C9C9C9;
  border-radius: 10px !important;
}
.template-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  border: 1px solid #C32E0E;
  border-radius: 8px;
  padding: 6px 16px !important;
}
.template-btn:hover {
  background: #FDE4DF;
  box-shadow: none !important;
}
.upload-box {
  border:1px dashed #949AA8;
  background: linear-gradient(100deg, #FFF2F2 0%, #FFFFFF 100%) !important;
  border-radius: 8px;
  padding:26px 20px;
  cursor:pointer;
  text-align:center;
  align-items:center;
  justify-content: center;
}
.upload-inner {
  display:flex;
  flex-direction:column;
  gap:8px;
  align-items:center;
}
.upload-btn-core {
  background:#ffffff;
  border:1px solid #C32E0E;
  color:#C32E0E;
  border-radius:12px;
  padding:8px 26px;
  font-size:13px;
  font-weight:500;
  cursor:pointer;
  display: flex;
  align-items: center;
  gap: 6px;
}
.upload-btn-core:hover {
  background:#FDE4DF;
  box-shadow:none !important;
}
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
:deep(thead) {
  background-color: #FFE4E1 !important;
  padding: 0 8px;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 700;
  font-size: 16px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 700;
  font-size: 16px;
}
.delete-dialog-group {
  margin-top: -180px;
}
.delete-dialog-card {
  border-radius: 12px !important;
  margin-top: -194px;
}
.card-dialog-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
}
.delete-dialog-title {
  margin-top: 8px;
  font-size: 16px !important;
  color: #C30000 !important;
  font-weight: 700 !important;
}
.delete-confirm-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  width: 120px;
  background-color: #C30000;
}
/* =============================================================================
   MAIN LAYOUT STYLES
   ============================================================================= */
.card {
  border-radius: 10px !important;
  height: 90vh;
  overflow: auto;
  margin: 0 0 2rem 0;
  padding: 0;
}

.text-ellipsis {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* =============================================================================
   MODERN TEXT FIELD STYLES
   ============================================================================= */
.modern-text-field {
  margin-top: 8px;
  box-shadow: none !important;
}

.modern-text-field :deep(.v-field) {
  border: 1px solid #c9c9c9 !important;
  border-radius: 12px !important;
  background: #ffffff !important;
  transition: all 0.3s ease !important;
}

.modern-text-field :deep(.v-field__outline) {
  border-width: 2px !important;
  transition: all 0.3s ease !important;
}
.modern-text-field :deep(.v-field--readonly) {
  background: #f8f9fa !important;
  opacity: 0.9;
}

.modern-text-field :deep(.v-field--readonly .v-field__outline) {
  border-color: rgba(0, 0, 0, 0.08) !important;
  border-style: dashed !important;
}

.modern-text-field :deep(.v-label) {
  font-weight: 600 !important;
  color: #495057 !important;
  font-size: 0.875rem !important;
  letter-spacing: 0.25px !important;
}
.modern-text-field :deep(.v-field__input) {
  font-size: 1rem !important;
  font-weight: 500 !important;
  color: #333 !important;
  padding: 16px 12px !important;
}

.modern-text-field :deep(.v-field--readonly .v-field__input) {
  color: #6c757d !important;
}

.modern-text-field :deep(.v-field__input::placeholder) {
  color: #adb5bd !important;
  font-style: italic;
}

.modern-text-field :deep(.v-field__prepend-inner) {
  padding-right: 8px !important;
}

.modern-text-field :deep(.v-field__append-inner) {
  padding-left: 8px !important;
}
.delete-selected-btn, .deletall-btn {
  display: flex;
  align-items: center;
  justify-self: unset;
  border: 1px solid #C32E0E;
  border-radius: 12px;
  padding: 8px 16px !important;
}
.delete-selected-btn:hover, .deletall-btn:hover {
  background: rgba(195, 0, 0, 0.1);
}
/* =============================================================================
   FILES DISPLAY STYLES
   ============================================================================= */
.files-card {
  border-radius: 8px;
  transition: all 0.2s ease;
}

.files-card:hover {
  border-color: rgba(var(--v-theme-primary), 0.3);
  box-shadow: 0 4px 12px rgba(var(--v-theme-on-surface), 0.08);
}

.files-card .v-card-title {
  background: rgba(var(--v-theme-surface-variant), 0.3);
  border-bottom: 1px solid rgba(var(--v-theme-on-surface), 0.08);
}

.file-item {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 10px;
  transition: background-color 0.2s ease;
}

.file-item:hover {
  background-color: rgba(var(--v-theme-primary), 0.04);
}

.file-item .v-btn:hover {
  background-color: rgba(var(--v-theme-error), 0.1) !important;
}

.v-virtual-scroll::-webkit-scrollbar {
  width: 4px;
}

.v-virtual-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.v-virtual-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(var(--v-theme-on-surface), 0.2);
  border-radius: 2px;
}

.v-virtual-scroll::-webkit-scrollbar-thumb:hover {
  background-color: rgba(var(--v-theme-on-surface), 0.3);
}

/* =============================================================================
   BUTTON STYLES
   ============================================================================= */
.upload-btn {
  text-transform: none;
  font-weight: 600;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(var(--v-theme-success), 0.2);
}

.upload-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(var(--v-theme-success), 0.3);
}

.process-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 16px !important;
  border-radius: 8px;
}
.process-btn:hover {
  background: #5878E9 !important;
}

.action-btn {
  transition: all 0.2s ease;
}

.delete-btn:hover {
  background-color: rgba(var(--v-theme-error), 0.1) !important;
  color: rgb(var(--v-theme-error)) !important;
}

/* =============================================================================
   DATA TABLE STYLES
   ============================================================================= */
:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}

:deep(.v-data-table .v-selection-control--dirty .v-selection-control__input),
:deep(.v-data-table .v-selection-control--dirty .v-icon),
:deep(.v-data-table .v-selection-control--indeterminate .v-selection-control__input),
:deep(.v-data-table .v-selection-control--indeterminate .v-icon) {
  color: #C32E0E !important;
}

/* =============================================================================
   ACTION BANNER STYLES
   ============================================================================= */
.action-banner {
  margin: 24px 0 16px 0;
  padding: 0 8px;
}

.banner-card {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%) !important;
  border: 1px solid rgba(var(--v-theme-on-surface), 0.08) !important;
  transition: all 0.3s ease;
}

.banner-card:hover {
  box-shadow: 0 4px 12px rgba(var(--v-theme-on-surface), 0.08) !important;
}

.banner-content {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-end !important;
  gap: 16px !important;
  padding: 16px 24px !important;
  min-height: 60px;
}

.delete-all-btn {
  border-radius: 12px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.5px !important;
  min-width: 140px !important;
  border-width: 2px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.delete-all-btn:hover {
  background-color: rgba(var(--v-theme-error), 0.08) !important;
  border-color: rgb(var(--v-theme-error)) !important;
  transform: translateY(-2px) !important;
}

.delete-all-btn:active {
  transform: translateY(0) !important;
}

.back-btn {
  background: linear-gradient(135deg, #a96500 0%, #b75d00 100%) !important;
  border-radius: 12px !important;
  font-weight: 700 !important;
  text-transform: uppercase !important;
  letter-spacing: 1px !important;
  min-width: 120px !important;
  box-shadow: 0 4px 15px rgba(255, 152, 0, 0.3) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  color: white !important;
}

.back-btn:hover {
  background: linear-gradient(135deg, #f57c00 0%, #e65100 100%) !important;
  transform: translateY(-2px) !important;
}

.back-btn .v-icon {
  color: white !important;
}

.delete-all-btn .v-icon,
.back-btn .v-icon {
  transition: transform 0.2s ease !important;
}

.delete-all-btn:hover .v-icon {
  transform: scale(1.1) rotate(-5deg) !important;
}

.back-btn:hover .v-icon {
  transform: scale(1.1) translateX(-2px) !important;
}

/* =============================================================================
   RESPONSIVE DESIGN
   ============================================================================= */
@media (max-width: 960px) {
  .d-flex.justify-end {
    justify-content: center !important;
  }
  
  .process-btn {
    min-width: 120px;
  }
}

@media (max-width: 768px) {
  .action-banner {
    margin: 16px 0 12px 0;
    padding: 0 4px;
  }
  
  .banner-content {
    padding: 12px 16px !important;
    gap: 12px !important;
    flex-direction: column-reverse !important;
    align-items: stretch !important;
  }
  
  .delete-all-btn,
  .back-btn {
    width: 100% !important;
    min-width: auto !important;
    justify-content: center !important;
  }
  
  .delete-all-btn {
    order: 2;
  }
  
  .back-btn {
    order: 1;
  }
}

@media (max-width: 600px) {
  .ga-3 {
    gap: 0.5rem !important;
  }
  
  .process-btn {
    font-size: 0.875rem;
    min-width: 100px;
  }

  .banner-content {
    gap: 8px !important;
  }
  
  .delete-all-btn,
  .back-btn {
    font-size: 0.875rem !important;
    padding: 12px 16px !important;
  }
  
  .back-btn {
    letter-spacing: 0.5px !important;
  }
  .process-btn,
  .upload-btn {
    font-size: 0.875rem;
    min-width: 100px;
  }
}
</style>
